import { apps } from '../rolesAndPermission';

export const tipsManagerModule = {
  'tips-management': {
    id: 54,
    moduleName: 'Tips Management',
  },
} as const;
export const tipsManagerModuleList = Object.entries(tipsManagerModule).map(([key, v]) => ({
  key,
  createdBy: 'System',
  ...v,
}));
export const tipsManagerFeatures = {
  'tips-pool': {
    id: 169,
    featureName: 'Tips Pool',
  },
} as const;
export const tipsManagerFeaturesList = Object.entries(tipsManagerFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: 'System',
}));

export const tipsAndEmployeeModules = [
  { appId: apps.dashboard.id, moduleId: tipsManagerModule['tips-management'].id },
  { appId: apps.dashboard.id, moduleId: 6 },
];

export const tipsManagerModuleFeatures = [
  { moduleId: tipsManagerModule['tips-management'].id, featureId: tipsManagerFeatures['tips-pool'].id },
];
